import React from "react";
import { Box } from "@mui/material";

interface IProps {
  status: string;
}

const WithdrawalPaymentStatus: React.FC<IProps> = ({ status }) => {
  return status === "on hold" ? (
    <Box textTransform="capitalize">on hold / investigation</Box>
  ) : (
    <Box textTransform="capitalize">{status}</Box>
  );
};

export default WithdrawalPaymentStatus;
